const routes=[
  { //诊所微官网
    path: '/clinicWeChatOfficialWebsite',
    component: () => import('@/pages/iframe/index.vue'),
    name: 'clinicWeChatOfficialWebsite',
  },
  //处置配置管理
  {
    path: "/prescriptionManagement",
    name: 'prescriptionManagement',
    meta: {
      title: '处置项目',
      hasBack: false
    },
    component: () => import('@/pages/medical/prescriptionManagement/index.vue'),
  },
  //预约项目配置管理
  {
    path: "/appointmentProject",
    name: 'appointmentProject',
    meta: {
      title: '预约项目',
      hasBack: false
    },
    component: () => import('@/pages/medical/appointmentProjectConfiguration/index.vue'),
  },
]
export default routes;
